import * as entity from '@common/domain/entities/StockItemFileCabinet'
import * as app from '@framework/app';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { IDataEndPoint, IFieldOptions } from '../../../framework/interfaces/IEntity';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
import { ViewType, FieldType } from '../../../framework/core/Enums';
import { appSettings } from '../../../modules/shared/components/appSettings';
export class StockItemFileCabinetEndPoints extends entity.StockItemFileCabinetEndPoints {
  get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/withFile/" + serviceCommand.context.entityId }, method: "GET" };
  update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/updateWithFile/" + serviceCommand.context.entityId }, method: "POST" };
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      debugger;
      return app.config.controllerRouteRoot + "/stockItemFileCabinet/createWithFile/" + serviceCommand.context.parent.previousEntityId
    }, method: "POST"
  };
}
export class StockItemFileCabinetPictureEndPoints extends entity.StockItemFileCabinetEndPoints {
  get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/withFile/" + serviceCommand.context.entityId }, method: "GET" };
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/lazyPicture/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/lazyPictureCount/" + serviceCommand.context.entityId }, method: "POST" };
}
export class StockItemFileCabinetDocumentEndPoints extends entity.StockItemFileCabinetEndPoints {
  get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/withFile/" + serviceCommand.context.entityId }, method: "GET" };
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/lazyDoc/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/lazyDocCount/" + serviceCommand.context.entityId }, method: "POST" };
}

export class StockItemFileCabinetFormFields extends entity.StockItemFileCabinetFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
      if (this["stockItemId"]) this.splice(this.indexOf(this["stockItemId"]), 1)
      if (this["fileCabinetId"]) this.splice(this.indexOf(this["fileCabinetId"]), 1)
      this.fileCabinetId.required = true;
      let file: IFieldOptions = {
        field: "file", required: true, viewType: ViewType.File, fieldType: FieldType.String, name: "File", dataDisplayField: "fileName", dataIdField: "fileCabinetId",
        dataEndPoint: { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/download/", method: "POST" },
        insertEndPoint: { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/uploadNewFiles", method: "POST" },
      };
      this.unshift(file);
      let description: IFieldOptions = { field: "description", fieldType: FieldType.String, name: "Description" };
      description.viewType = ViewType.Text;
      this.push(description);

    } catch  { }
  }
}

export class StockItemFileCabinetForm extends entity.StockItemFileCabinetForm {
  protected stockItemFileCabinetFormEndPoints: StockItemFileCabinetEndPoints = new StockItemFileCabinetEndPoints();
  protected stockItemFileCabinetFormFields: StockItemFileCabinetFormFields = new StockItemFileCabinetFormFields();

  public canDelete?: boolean = true;
}

export class StockItemFileCabinetListColumns extends entity.StockItemFileCabinetListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
      if (this["stockItemId"]) this.splice(this.indexOf(this["stockItemId"]), 1)
      this.fileCabinetId.visible = false;
      

     // this.push(FormBuilderControlListHelper.getListColumn("fileCabinet.fileName", "Filename", null, null, "fileCabinet_fileName"));
      this.push(FormBuilderControlListHelper.getListColumn("fileCabinet.description", "Description", null, null, "fileCabinet_description"));
      let file: IFieldOptions = FormBuilderControlListHelper.getListColumn("fileCabinet.fileName", "Filename", null, null, "file");
      file.formBuilderControl.controlType.viewType = ViewType.Thumbnail;
      file.viewType = ViewType.Thumbnail;
      file.dataDisplayField = "fileName";
      file.dataIdField = "fileCabinetId",
        file.dataEndPoint = { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/download/", method: "POST" };
      file.insertEndPoint = { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/uploadNewFiles", method: "POST" };
      file.readOnly = false;
      this.unshift(file);
    } catch  { }
  }
}

export class StockItemFileCabinetPictureList extends entity.StockItemFileCabinetList {
  protected stockItemFileCabinetListEndPoints: StockItemFileCabinetPictureEndPoints = new StockItemFileCabinetPictureEndPoints();
  protected stockItemFileCabinetListColumns: StockItemFileCabinetListColumns = new StockItemFileCabinetListColumns();
}
export class StockItemFileCabinetDocList extends entity.StockItemFileCabinetList {
  protected stockItemFileCabinetListEndPoints: StockItemFileCabinetDocumentEndPoints = new StockItemFileCabinetDocumentEndPoints();
  protected stockItemFileCabinetListColumns: StockItemFileCabinetListColumns = new StockItemFileCabinetListColumns();
}

export class BladeSetup {
  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(2);
      prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(3);
      prop.parent.parent.getBladeByIndex(0).reloadFormByIndex(0);
    }
  }
  public onFormLoad: Function = function (data: any, formIndex?: any, context?: any) {

  }
}

//export class StockItemFileCabinetGeneratedForm extends entity.StockItemFileCabinetGeneratedForm {
  //protected detailPageComponentForm: StockItemFileCabinetForm = new StockItemFileCabinetForm();
//};

//export class StockItemFileCabinetListPageComponent extends entity.StockItemFileCabinetListPageComponent {
  //protected listPageComponentList: StockItemFileCabinetList = new StockItemFileCabinetList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class StockItemFileCabinetBlade extends entity.StockItemFileCabinetBlade {};
//export class StockItemFileCabinetListBlade extends entity.StockItemFileCabinetListBlade {};

